export default __webpack_public_path__ + "static/media/Rasmita Panda.594d6961.JPG";